import { translate } from "./mfb-labels";

const ROWS = [
	["MFB5", "10.5 (0.64)", "19.0 (5.0)", "1800", "3600", "100 (1500)", "210 (3000)", "15.3 (135)", "30.5 (270)", "11"],
	["MFB10", "21.1 (1.29)", "37.9 (10.0)", "1800", "3200", "100 (1500)", "210 (3000)", "32.1 (284)", "64.2 (568)", "21"],
	["MFB20", "42.8 (2.61)", "75.7 (20.0)", "1800", "2400", "100 (1500)", "175 (2500)", "50.9 (450)", "101.7 (900)", "49"],
	["MFB29", "61.6 (3.76)", "109.8 (29.0)", "1800", "2400", "70 (1000)", "140 (2000)", "58.8 (520)", "117.5 (1040)", "49"],
	["MFB45", "94.4 (5.76)", "170.3 (45.0)", "1800", "2200", "100 (1500)", "210 (3000)", "135.7 (1200)", "271.2 (2400)", "73"],
];

export default function MfbDesempeno({ locale = "es" }) {
	const t = (value) => translate(locale, value);
	const heads = [
		"Modelo",
		"Desplazamiento cm³ (pulg.³)/rev.",
		"Caudal LPM (GPM) a 1800 RPM",
		"Velocidad de operación RPM",
		"Presión bar (psi)",
		"Par de salida Nm (lb in)",
		"Peso (lb)",
	];
	return (
		<div className="tu-product-table-wrap">
			<table className="table table-hover table-striped table-bordered">
				<caption className="product-title-table-text">{t("Especificaciones")}</caption>
				<thead>
					<tr className="inside-table-text">
						<th rowSpan={2}>{t(heads[0])}</th>
						<th rowSpan={2}>{t(heads[1])}</th>
						<th rowSpan={2}>{t(heads[2])}</th>
						<th colSpan={2}>{t(heads[3])}</th>
						<th colSpan={2}>{t(heads[4])}</th>
						<th colSpan={2}>{t(heads[5])}</th>
						<th rowSpan={2}>{t(heads[6])}</th>
					</tr>
					<tr className="inside-table-text">
						<th>{t("Nominal")}</th>
						<th>{t("Máx.")}</th>
						<th>{t("Nominal")}</th>
						<th>{t("Máx.")}</th>
						<th>{t("Nominal")}</th>
						<th>{t("Máx.")}</th>
					</tr>
				</thead>
				<tbody>
					{ROWS.map((row) => (
						<tr className="inside-table-text" key={row[0]}>
							{row.map((cell, index) => (
								<td key={index}>{cell}</td>
							))}
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
}
